<template>
  <DashboardTableWrapper
    title="Factures impayees"
    :loading="loading"
    :error="error"
    :has-data="!!data && data.length > 0"
    @retry="refresh"
  >
    <table class="w-full text-sm">
      <thead>
        <tr class="bg-gray-50 text-left">
          <th class="px-4 py-3 font-semibold text-gray-600">N Facture</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Client</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Telephone</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Montant total</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Paye</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Reste a payer</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Statut</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Echeance</th>
          <th class="px-4 py-3 font-semibold text-gray-600">Creee le</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in data" :key="item.id" class="border-t border-gray-100 hover:bg-gray-50">
          <td class="px-4 py-3 font-medium text-gray-800">{{ item.invoice_number }}</td>
          <td class="px-4 py-3 text-gray-600">{{ item.customer || '—' }}</td>
          <td class="px-4 py-3 text-gray-500">{{ item.customer_phone || '—' }}</td>
          <td class="px-4 py-3 font-semibold">{{ formatCurrency(item.total_amount) }}</td>
          <td class="px-4 py-3 text-green-600 font-semibold">{{ formatCurrency(item.paid_amount) }}</td>
          <td class="px-4 py-3 text-red-600 font-bold">{{ formatCurrency(item.remaining) }}</td>
          <td class="px-4 py-3">
            <BaseBadge :variant="statusVariant(item.status)" size="sm">
              {{ statusLabel(item.status) }}
            </BaseBadge>
          </td>
          <td class="px-4 py-3 text-gray-500">{{ formatDateDisplay(item.due_date) }}</td>
          <td class="px-4 py-3 text-gray-500">{{ formatDateDisplay(item.created_at) }}</td>
        </tr>
      </tbody>
    </table>
  </DashboardTableWrapper>
</template>

<script setup>
import { useDashboard } from '@/composables/useDashboard'
import { formatCurrency } from './helpers'
import DashboardTableWrapper from './DashboardTableWrapper.vue'
import BaseBadge from '@/components/base/BaseBadge.vue'

const { data, loading, error, refresh } = useDashboard('/dashboard/tables/unpaid-invoices', { limit: 20 })

const statusLabels = {
  pending: 'Impayee',
  partial: 'Partielle'
}

const statusVariants = {
  pending: 'danger',
  partial: 'warning'
}

const statusLabel = (s) => statusLabels[s] || s
const statusVariant = (s) => statusVariants[s] || 'gray'

const formatDateDisplay = (d) => {
  if (!d) return '—'
  return new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' })
}
</script>
